var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};

export var getWidth = function getWidth() {
  if (isBrowser()) return window.innerWidth;
  return 1000;
};